import { render, staticRenderFns } from "./PartnersTemplate.vue?vue&type=template&id=1c74031f"
import script from "./PartnersTemplate.vue?vue&type=script&lang=js"
export * from "./PartnersTemplate.vue?vue&type=script&lang=js"
import style0 from "./PartnersTemplate.vue?vue&type=style&index=0&id=1c74031f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports